export default function useId() {
  return window.localStorage.getItem("THE_ID");
}
